var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16961 -16417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17026.959 16361.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.305,68.912a1.876,1.876,0,0,1-.658.345,2.554,2.554,0,0,1-.694.106,2.933,2.933,0,0,1-1-.156,2.382,2.382,0,0,1-.718-.4,2.076,2.076,0,0,1-.469-.55,2.955,2.955,0,0,1-.279-.641l-.034-.113-1.6.287.039.139a3.652,3.652,0,0,0,.4.909,3.9,3.9,0,0,0,.7.863,4.093,4.093,0,0,0,1,.684,4.012,4.012,0,0,0,1.206.358v2.113h1.5V70.724a3.784,3.784,0,0,0,1.178-.409,3.611,3.611,0,0,0,.981-.785,3.4,3.4,0,0,0,.617-1.046,3.457,3.457,0,0,0,.214-1.207,3.778,3.778,0,0,0-.286-1.531,3.543,3.543,0,0,0-.75-1.1,4.161,4.161,0,0,0-1.074-.756,12.417,12.417,0,0,0-1.224-.521,8.589,8.589,0,0,1-1.219-.533,3.132,3.132,0,0,1-.718-.518,1.334,1.334,0,0,1-.33-.524,2.1,2.1,0,0,1-.087-.622,1.767,1.767,0,0,1,.158-.777,1.506,1.506,0,0,1,.417-.529,1.725,1.725,0,0,1,.616-.3,2.821,2.821,0,0,1,.757-.1,1.977,1.977,0,0,1,1.413.48,2.622,2.622,0,0,1,.712,1.13l.034.113,1.535-.291-.045-.142a4.284,4.284,0,0,0-.4-.877,3.87,3.87,0,0,0-.623-.793,3.665,3.665,0,0,0-.864-.616,3.468,3.468,0,0,0-1.012-.33V56.18H76.2v1.941a3.377,3.377,0,0,0-2.071,1.023,3.147,3.147,0,0,0-.782,2.185,3.088,3.088,0,0,0,.61,1.857,4.415,4.415,0,0,0,1.983,1.377q.8.326,1.4.583a4.212,4.212,0,0,1,.951.55,1.79,1.79,0,0,1,.538.681A2.521,2.521,0,0,1,79,67.4a1.879,1.879,0,0,1-.2.9A2.058,2.058,0,0,1,78.305,68.912Z",
    transform: "translate(0.48 0.305)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,0,6,5H0Z",
    transform: "translate(-16961 16417)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 8,
    transform: "translate(-16959 16420)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33899 32853) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,0,6,5H0Z",
    transform: "translate(-16961 16417)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 9,
    transform: "translate(-16959 16420)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePrice);
export default __webpack_public_path__ + "static/media/createPrice.d5ab99187a5413a1e55b89a6f40d5c74.svg";
export { ForwardRef as ReactComponent };